<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div mat-dialog-title class="matDialogTitle" cdkDragHandle>
        <div class="div_loading">
            <div class="my-container" [hidden]="!loading">
                <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
            </div>
        </div>
        <span>
            <span>{{ title }}</span>
        </span>
        <span (click)="close()">
            <mat-icon class="close">close</mat-icon>
        </span>
    </div>
</div>



<div mat-dialog-content class="matDialogContent">
    <div class="row pe1">
        <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
            *ngFor="let x of list_cate2;let i = index">
            <label for="title" class='wh-label'>
                <span style="float: left" (click)="load_services(171,x.wharehouse_material_cate2_id)">
                    <i class="fas fa-info-circle icon"></i>
                </span>
                <span *ngIf="lang == 1"> {{ x.wharehouse_material_cate2_title }}: </span>
                <input class="wh-input" readonly
                    (click)="open_detaile(i , x.wharehouse_material_cate2_id,x.wharehouse_material_cate2_title)"
                    readonly [value]="x.amount" [ngStyle]="{ 'background':x.amount > 0 ? '#acdbac' : '#dba6a6'}">
            </label>
        </div>
    </div>
</div>